export type SuperGridType = 'skipcheck' | 'skipall' | 'skipallnumeric';
interface GridDefs {
  grid: string;
  description: string;
}

export const superGrids: Record<SuperGridType, GridDefs> = {
  skipcheck: {
    grid: 'SKIPCHECK000',
    description: 'Skips all validity checks in frontend',
  },
  skipall: {
    grid: 'SKIPALL000',
    description: 'Skips all validity checks in frontend and sets Swabtimers to 1second',
  },
  skipallnumeric: {
    grid: '28051991',
    description: 'Numeric only equivalent to SKIPALL000',
  },
};
